module.exports = __webpack_public_path__ + "img/oufu_65x85x10b.prt.5b452acf.jpg";